var _filter, _linearGradient, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _linearGradient2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirefox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 200,
    width: 196,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "firefox_svg__a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 200,
    width: 194.901,
    x: 0.147,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 159.176,
    x2: 30.445,
    y1: 34.788,
    y2: 158.989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#ffe847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#ffc830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#ff8b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#ff672a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#e31587"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__c",
    cx: 153.228,
    cy: 27.757,
    gradientUnits: "userSpaceOnUse",
    r: 161.66
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#ffbd4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#ffac31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#ff9d17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#ff563b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#ff3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f5156c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#eb0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#e50080"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__d",
    cx: 94.156,
    cy: 93.849,
    gradientUnits: "userSpaceOnUse",
    r: 161.66
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960e18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#b11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#db293d",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#f5334b",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff3750",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__e",
    cx: 113.645,
    cy: -8.93,
    gradientUnits: "userSpaceOnUse",
    r: 117.116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#ffdc3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#ff9d12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#ff980e"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__f",
    cx: 76.275,
    cy: 136.075,
    gradientUnits: "userSpaceOnUse",
    r: 76.974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3a8ee6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5c79f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c139e6"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__g",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(39.6681 -9.59057 11.22816 46.44146 102.99 80.6)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8c4ff3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716a8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6e008b",
    stopOpacity: 0.6
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__h",
    cx: 92.115,
    cy: 21.143,
    gradientUnits: "userSpaceOnUse",
    r: 55.375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#ffdb27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#ffc82a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ffa930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#ff7e37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#ff7139"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__i",
    cx: 135.641,
    cy: -13.981,
    gradientUnits: "userSpaceOnUse",
    r: 236.259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#ff5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#e31587"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__j",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(18.17228 172.20381 -113.01547 11.92627 115.728 -.844)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ffe847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#ffc830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#ff8b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#ff672a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#e31587"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__k",
    cx: 90.811,
    cy: 41.653,
    gradientUnits: "userSpaceOnUse",
    r: 147.501
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#ff5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#e31587"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__l",
    cx: 129.747,
    cy: 50.286,
    gradientUnits: "userSpaceOnUse",
    r: 161.438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#ffe141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#ffaf1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#ff980e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox_svg__m",
    gradientUnits: "userSpaceOnUse",
    x1: 157.63,
    x2: 48.093,
    y1: 34.124,
    y2: 143.659
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#fff44f",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#fff44f",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff44f",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff44f",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#firefox_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.441 63.676c-3.37-8.107-10.205-16.861-15.557-19.628a80.566 80.566 0 017.854 23.537l.014.13c-8.768-21.858-23.636-30.672-35.779-49.864a94.167 94.167 0 01-1.827-2.97 24.482 24.482 0 01-.854-1.6 14.107 14.107 0 01-1.157-3.071.195.195 0 00-.05-.134.198.198 0 00-.126-.066.277.277 0 00-.146 0c-.01 0-.026.018-.038.022s-.038.022-.056.03l.03-.052c-19.478 11.404-26.087 32.517-26.695 43.078a38.79 38.79 0 00-21.34 8.225 23.192 23.192 0 00-2.001-1.517 35.95 35.95 0 01-.219-18.953A57.434 57.434 0 0052.83 55.267h-.036c-3.074-3.895-2.857-16.74-2.681-19.424-.91.366-1.777.827-2.59 1.375a56.469 56.469 0 00-7.579 6.493 67.712 67.712 0 00-7.249 8.697v.012-.014A65.493 65.493 0 0022.29 75.903l-.104.512c-.146.682-.672 4.1-.762 4.842 0 .058-.012.112-.018.17a73.906 73.906 0 00-1.259 10.69v.4a77.552 77.552 0 0070.97 77.203 77.55 77.55 0 0083.002-64.089c.13-1 .236-1.991.352-3.001a79.75 79.75 0 00-5.03-38.954zm-89.377 60.701c.362.174.702.362 1.074.528l.054.034c-.376-.18-.752-.367-1.128-.562zm81.694-56.643v-.074l.014.082z",
    fill: "url(#firefox_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.441 63.676c-3.37-8.107-10.205-16.86-15.557-19.628a80.566 80.566 0 017.854 23.538v.074l.014.082a70.23 70.23 0 01-2.413 52.337c-8.888 19.07-30.401 38.616-64.075 37.666-36.385-1.031-68.428-28.03-74.418-63.392-1.09-5.577 0-8.404.548-12.936a57.769 57.769 0 00-1.247 10.7v.4a77.552 77.552 0 0070.97 77.203 77.55 77.55 0 0083.002-64.089c.13-1 .236-1.991.352-3.001a79.75 79.75 0 00-5.03-38.954z",
    fill: "url(#firefox_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.441 63.676c-3.37-8.107-10.205-16.86-15.557-19.628a80.566 80.566 0 017.854 23.538v.074l.014.082a70.23 70.23 0 01-2.413 52.337c-8.888 19.07-30.401 38.616-64.075 37.666-36.385-1.031-68.428-28.03-74.418-63.392-1.09-5.577 0-8.404.548-12.936a57.769 57.769 0 00-1.247 10.7v.4a77.552 77.552 0 0070.97 77.203 77.55 77.55 0 0083.002-64.089c.13-1 .236-1.991.352-3.001a79.75 79.75 0 00-5.03-38.954z",
    fill: "url(#firefox_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.757 72.792c.168.118.324.236.482.354a42.197 42.197 0 00-7.203-9.394c-24.102-24.106-6.316-52.268-3.317-53.698l.03-.044c-19.478 11.405-26.087 32.517-26.695 43.078.904-.062 1.8-.139 2.725-.139a39.137 39.137 0 0133.978 19.843z",
    fill: "url(#firefox_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.83 77.606c-.129 1.929-6.944 8.581-9.327 8.581-22.05 0-25.63 13.34-25.63 13.34.976 11.232 8.804 20.484 18.265 25.378.433.224.87.426 1.309.624.759.337 1.518.647 2.277.933a34.514 34.514 0 0010.09 1.947c38.65 1.812 46.137-46.22 18.246-60.157a26.77 26.77 0 0118.697 4.54 39.135 39.135 0 00-33.978-19.843c-.92 0-1.82.077-2.725.139a38.79 38.79 0 00-21.34 8.225c1.182 1 2.516 2.337 5.327 5.108C84.304 71.605 97.8 76.975 97.83 77.606z",
    fill: "url(#firefox_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.83 77.606c-.129 1.929-6.944 8.581-9.327 8.581-22.05 0-25.63 13.34-25.63 13.34.976 11.232 8.804 20.484 18.265 25.378.433.224.87.426 1.309.624.759.337 1.518.647 2.277.933a34.514 34.514 0 0010.09 1.947c38.65 1.812 46.137-46.22 18.246-60.157a26.77 26.77 0 0118.697 4.54 39.135 39.135 0 00-33.978-19.843c-.92 0-1.82.077-2.725.139a38.79 38.79 0 00-21.34 8.225c1.182 1 2.516 2.337 5.327 5.108C84.304 71.605 97.8 76.975 97.83 77.606z",
    fill: "url(#firefox_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.098 58.734c.628.4 1.146.748 1.6 1.062a35.952 35.952 0 01-.218-18.954 57.433 57.433 0 00-18.665 14.426c.378-.01 11.626-.212 17.283 3.466z",
    fill: "url(#firefox_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.856 94.353c5.984 35.362 38.033 62.361 74.418 63.392 33.674.952 55.187-18.596 64.075-37.666a70.23 70.23 0 002.413-52.337v-.075c0-.058-.012-.092 0-.074l.014.13c2.751 17.962-6.385 35.363-20.667 47.13l-.044.1c-27.827 22.663-54.458 13.674-59.849 10.004-.376-.18-.752-.367-1.128-.562-16.225-7.755-22.927-22.537-21.49-35.215a19.913 19.913 0 01-18.37-11.554 29.248 29.248 0 0128.51-1.145 38.616 38.616 0 0029.115 1.145c-.03-.63-13.525-6.003-18.787-11.185-2.812-2.771-4.146-4.106-5.329-5.108a23.214 23.214 0 00-2-1.517c-.46-.314-.979-.654-1.601-1.062-5.656-3.678-16.905-3.476-17.277-3.466h-.036c-3.073-3.895-2.857-16.74-2.681-19.424-.91.366-1.777.827-2.59 1.375a56.475 56.475 0 00-7.579 6.493 67.724 67.724 0 00-7.278 8.677v.012-.014A65.493 65.493 0 0022.29 75.903c-.038.158-2.793 12.203-1.434 18.45z",
    fill: "url(#firefox_svg__i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.04 63.752a42.215 42.215 0 017.203 9.404c.427.322.825.642 1.163.952 17.581 16.207 8.369 39.116 7.683 40.747 14.282-11.767 23.41-29.168 20.667-47.13-8.772-21.868-23.64-30.682-35.783-49.874a94.167 94.167 0 01-1.827-2.97 24.482 24.482 0 01-.854-1.6 14.107 14.107 0 01-1.157-3.071.195.195 0 00-.05-.134.198.198 0 00-.126-.066.277.277 0 00-.146 0c-.01 0-.026.018-.038.022s-.038.022-.056.03c-2.999 1.422-20.784 29.584 3.321 53.69z",
    fill: "url(#firefox_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.394 74.098a15.95 15.95 0 00-1.163-.952c-.158-.118-.314-.236-.482-.354a26.77 26.77 0 00-18.698-4.54c27.892 13.946 20.409 61.969-18.245 60.157a34.514 34.514 0 01-10.09-1.947 40.399 40.399 0 01-2.277-.933c-.438-.2-.877-.4-1.309-.624l.054.034c5.39 3.68 32.014 12.669 59.849-10.004l.044-.1c.694-1.621 9.906-24.536-7.683-40.737z",
    fill: "url(#firefox_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.873 99.527s3.58-13.34 25.63-13.34c2.384 0 9.204-6.653 9.326-8.581a38.616 38.616 0 01-29.116-1.145 29.247 29.247 0 00-28.51 1.145 19.915 19.915 0 0018.37 11.554c-1.436 12.68 5.266 27.462 21.491 35.215.362.174.702.362 1.075.528-9.47-4.892-17.29-14.144-18.266-25.376z",
    fill: "url(#firefox_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.441 63.676c-3.37-8.107-10.205-16.861-15.557-19.628a80.566 80.566 0 017.854 23.537l.014.13c-8.768-21.858-23.636-30.672-35.779-49.864a94.167 94.167 0 01-1.827-2.97 24.482 24.482 0 01-.854-1.6 14.107 14.107 0 01-1.157-3.071.195.195 0 00-.05-.134.198.198 0 00-.126-.066.277.277 0 00-.146 0c-.01 0-.026.018-.038.022s-.038.022-.056.03l.03-.052c-19.478 11.404-26.087 32.517-26.695 43.078.905-.063 1.8-.139 2.725-.139a39.137 39.137 0 0133.978 19.843 26.77 26.77 0 00-18.698-4.54c27.892 13.945 20.409 61.969-18.245 60.157a34.514 34.514 0 01-10.09-1.947 40.43 40.43 0 01-2.277-.933c-.438-.2-.876-.4-1.309-.624l.054.034c-.376-.18-.752-.367-1.128-.562.362.174.702.362 1.074.528-9.47-4.894-17.289-14.146-18.265-25.378 0 0 3.58-13.34 25.63-13.34 2.383 0 9.204-6.653 9.326-8.581-.03-.63-13.525-6.003-18.787-11.185-2.812-2.771-4.146-4.106-5.329-5.108a23.192 23.192 0 00-2-1.517 35.95 35.95 0 01-.219-18.953A57.434 57.434 0 0052.83 55.268h-.036c-3.074-3.895-2.857-16.74-2.681-19.423-.91.365-1.777.826-2.59 1.374a56.469 56.469 0 00-7.579 6.493 67.712 67.712 0 00-7.249 8.697v.012-.014A65.493 65.493 0 0022.29 75.903l-.104.512c-.146.682-.8 4.148-.894 4.892a90.217 90.217 0 00-1.145 10.81v.4a77.552 77.552 0 0070.97 77.203 77.55 77.55 0 0083.002-64.089c.13-1 .236-1.991.352-3.001a79.75 79.75 0 00-5.03-38.954zm-7.693 3.983l.014.083z",
    fill: "url(#firefox_svg__m)"
  }))));
}
export default __webpack_public_path__ + "static/media/firefox.51cafb5e0643abc6eac11e8a362fb387.svg";
export { SvgFirefox as ReactComponent };